"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useIdentity } from "@/hooks/useIdentity";
import { useParams } from "next/navigation";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import UserPageSetUpProfileWrapper from "../utils/set-up-profile/UserPageSetUpProfileWrapper";
import UserPageRep from "./UserPageRep";
export default function UserPageRepWrapper(t0) {
  const $ = _c(12);
  const {
    profile: initialProfile,
    initialActivityLogParams
  } = t0;
  const params = useParams();
  const t1 = params.user as string;
  let t2;
  if ($[0] !== t1) {
    t2 = t1.toLowerCase();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const user = t2;
  let t3;
  if ($[2] !== initialProfile || $[3] !== user) {
    t3 = {
      handleOrWallet: user,
      initialProfile
    };
    $[2] = initialProfile;
    $[3] = user;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    profile
  } = useIdentity(t3);
  const t4 = profile ?? initialProfile;
  const t5 = profile ?? initialProfile;
  let t6;
  if ($[5] !== initialActivityLogParams || $[6] !== t5 || $[7] !== user) {
    t6 = <UserPageRep key={user} profile={t5} initialActivityLogParams={initialActivityLogParams} />;
    $[5] = initialActivityLogParams;
    $[6] = t5;
    $[7] = user;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <UserPageSetUpProfileWrapper profile={t4}>{t6}</UserPageSetUpProfileWrapper>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}